import React, {useState, useEffect} from 'react';
import logo from '../../images/logo.png';
import {FaBars} from 'react-icons/fa';
import {animateScroll as scroll} from 'react-scroll';
import {
  NavCon, 
  NavBarContainer, 
  NavLogo, 
  MobileIcon, 
  NavMenu, 
  NavItem, 
  NavLinks,
  NavBtn,
  NavBtnLink

} from './HeaderElem'

const Header = ({toggle}) => {

  const [scrollNav, setScrollNav] = useState(false);

    const changeNav = () => {
        if(window.scrollY >= 80) {
            setScrollNav(true)
        } else {
            setScrollNav(false)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', changeNav)
    })

    const toggleHome = () => {
      scroll.scrollToTop();
  }

 
  return (

    
    <>
      <NavCon scrollNav = {scrollNav}>
        <NavBarContainer>
          <NavLogo to="/" onClick={toggleHome}
          >
            <img src={logo} style={{maxHeight:"50px"}}></img>
            
          </NavLogo>
          <MobileIcon onClick={toggle}>
            <FaBars></FaBars>
          </MobileIcon>

          <NavMenu>
            <NavItem>
              <NavLinks to="pocetna"
              smooth={true} duration={500} spy={true} exact='true' offset={-80}
              >Početna</NavLinks>
              </NavItem>

              <NavItem>
              <NavLinks to="about"
              smooth={true} duration={500} spy={true} exact='true' offset={-80}
              >O konferenciji</NavLinks>
              </NavItem>

              <NavItem>
              <NavLinks to="presenters"
              smooth={true} duration={500} spy={true} exact='true' offset={-80}
              >Izlagači</NavLinks>
              </NavItem>

              <NavItem>
              <NavLinks to="raspored"
              smooth={true} duration={500} spy={true} exact='true' offset={-80}
              >Raspored</NavLinks>
              </NavItem>

              <NavItem>
              <NavLinks to="slike"
              smooth={true} duration={500} spy={true} exact='true' offset={-80}
              >Slike</NavLinks>
              </NavItem>

              <NavItem>
              <NavLinks to="kontakt"
              smooth={true} duration={500} spy={true} exact='true' offset={-80}
              >Kontakt</NavLinks>
              
            </NavItem>

            <NavBtn>
              <NavBtnLink to="prijavise"
              smooth={true} duration={500} spy={true} exact='true' offset={-80}
              >
                Prijavi Se
              </NavBtnLink>
            </NavBtn>
          </NavMenu>
        </NavBarContainer>
      </NavCon>
    </>

      
  );
}

export default Header
